import { combineReducers } from 'redux';
import reducers from './modules';
import storage from 'redux-persist/lib/storage';

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        Object.keys(state).forEach(key => {
            storage.removeItem(`persist:${key}`);
        });
        state = undefined;
    }
    return appReducer(state, action)
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux-modules/rootReducer.js